<button
  class="btn btn-info"
  style="margin-bottom: 12px; width: fit-content"
  data-toggle="modal"
  data-target="#orderModal"
>
  Order
</button>

<div class="modal fade" id="orderModal" tabindex="-1" role="dialog">
  <ngx-spinner fullScreen="false" name="changeOrderSpinner">
    Saving order...
  </ngx-spinner>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Order</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-hover custom-table">
          <tbody>
            <tr *ngFor="let element of array">
              <td>{{ array.indexOf(element) + 1 }} - {{ element.name }}</td>
              <td
                class="align-items-end align-self-end align-content-end float-right"
              >
                <button
                  class="btn btn-primary"
                  (click)="orderUp(element)"
                  [disabled]="array.indexOf(element) === 0"
                >
                  <i class="fas fa-arrow-up"></i>
                </button>
                <button
                  class="btn btn-primary ml-2"
                  (click)="orderDown(element)"
                  [disabled]="array.indexOf(element) === array.length - 1"
                >
                  <i class="fas fa-arrow-down"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success" (click)="orderAlphabetically()">
          Order Alphabetically
        </button>
        <button
          class="btn btn-primary"
          data-dismiss="modal"
          (click)="emitSaveEvent()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
